import { RematchDispatch, RematchRootState } from '@rematch/core';
import { connect } from 'react-redux';
import { Project, ProjectType, Service } from '../../../types';
import { RootModel } from '../../../state';
import { ProjectSelectionContainer } from './ProjectSelectionContainer';

export const mapState = (state: RematchRootState<RootModel>) => ({
  tabId: state.projects.projectTab,
  project: state.projects.project,
  favorites: state.projects.favorites,
  mrus: state.projects.mrus,
  all: state.projects.all,
  searched: state.projects.searched,
});

export const mapDispatch = (dispatch: RematchDispatch<RootModel>) => ({
  setProject: (project: Project) => dispatch.projects.setProject(project),
  setProjectsTab: (tabId: string) => dispatch.projects.setProjectsTab(tabId),
  setSearchPhrase: (searchPhrase: string) =>
    dispatch.projects.setSearchPhrase(searchPhrase),
  setRunSearch: (runSearch: boolean) =>
    dispatch.projects.setRunSearch(runSearch),
  filterProjects: async (search: {
    phrase: string;
    projectType: ProjectType;
  }) => dispatch.projects.filterProjects(search),
  loadProjects: async () => dispatch.projects.loadProjects({}),
  loadServices: async () => dispatch.services.loadServices({}),
  setService: (service?: Service) => dispatch.services.setService(service),
  resetConnection: () => dispatch.connections.resetConnection(),
});

export const ConnectedProjectSelection = connect(
  mapState,
  mapDispatch
)(ProjectSelectionContainer);
